import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 管理员列表
  queryAdminList (params) {
    return axios.post('/api/rendering/admin/base/user/queryAdminList', params)
  },
  // 根据id查询管理员
  queryAdminById (params) {
    return axios.post('/api/rendering/admin/base/user/queryAdminById', params)
  },
  // 添加管理员
  addAdmin (params) {
    return axios.post('/api/rendering/admin/base/user/addAdmin', params)
  },
  // 更新管理员
  updateAdmin (params) {
    return axios.post('/api/rendering/admin/base/user/updateAdmin', params)
  },
  // 清除用户数据
  cleanAdminUserData (params) {
    return axios.post('/api/rendering/admin/base/user/cleanAdminUserData', params)
  },
  // 查询所有部门组织
  queryOrganizationList (params) {
    return axios.post('/api/rendering/admin/base/user/queryOrganizationList', params)
  },
  // 根据部门id查询所有职位
  queryPositionListByOrganizationId (params) {
    return axios.post('/api/rendering/admin/base/user/queryPositionListByOrganizationId', params)
  },
  // 根据管理员id查询所有角色
  queryRoleListByLoginAdminId (params) {
    return axios.post('/api/rendering/admin/base/user/queryRoleListByLoginAdminId', params)
  },
  // 验证管理员用户名是否存在
  validateAdminName (params) {
    return axios.post('/api/rendering/admin/base/user/validateAdminName', params)
  },
  // 验证管理员手机号是否存在
  validateAdminPhone (params) {
    return axios.post('/api/rendering/admin/base/user/validateAdminPhone', params)
  },
  // 验证管理员邮箱是否存在
  validateAdminEmail (params) {
    return axios.post('/api/rendering/admin/base/user/validateAdminEmail', params)
  },
  // 代理列表
  queryAgentList (params) {
    return axios.post('/api/rendering/admin/base/user/agent/queryAgentList', params)
  },
  // 添加代理
  addAgent (params) {
    return axios.post('/api/rendering/admin/base/user/agent/addAgent', params)
  },
  // 更新代理
  updateAgent (params) {
    return axios.post('/api/rendering/admin/base/user/agent/updateAgent', params)
  },
  // 给代理分配业务
  allocateAgentAdmin (params) {
    return axios.post('/api/rendering/admin/base/user/agent/allocateAgentAdmin', params)
  },
  // 给代理充值
  rechargeAgent (params) {
    return axios.post('/api/rendering/admin/base/user/agent/rechargeAgent', params)
  },
  // 部门管理
  // 展示部门列表
  queryOrganization (params) {
    return axios.post('/api/rendering/admin/base/user/organization/queryOrganizationList', params)
  },
  // 根据职位id查询管理员
  queryAdminByPositionId (params) {
    return axios.post('/api/rendering/admin/base/user/organization/queryAdminByPositionId', params)
  },
  // 根据部门id查询管理员
  queryAdminByOrganizationId (params) {
    return axios.post('/api/rendering/admin/base/user/organization/queryAdminByOrganizationId', params)
  },
  // 根据部门id删除部门
  deleteOrganization (params) {
    return axios.post('/api/rendering/admin/base/user/organization/deleteOrganization', params)
  },
  // 添加部门
  addOrganization (params) {
    return axios.post('/api/rendering/admin/base/user/organization/addOrganization', params)
  },
  // 更新部门
  updateOrganization (params) {
    return axios.post('/api/rendering/admin/base/user/organization/updateOrganization', params)
  },
  // 权限列表
  queryRoleList (params) {
    return axios.post('/api/rendering/admin/base/user/role/queryRoleList', params)
  },
  // 添加权限
  addRole (params) {
    return axios.post('/api/rendering/admin/base/user/role/addRole', params)
  },
  // 克隆权限
  clonePermission (params) {
    return axios.post('/api/rendering/admin/base/user/role/cloneRolePermissions', params)
  },
  // 删除权限
  deleteRole (params) {
    return axios.post('/api/rendering/admin/base/user/role/deleteRole', params)
  },
  // 修改权限名
  changePermissionName (params) {
    return axios.post('/api/rendering/admin/base/user/role/updateRole', params)
  },
  // 根据角色id查询角色权限
  queryPermissionByRoleId (params) {
    return axios.post('/api/rendering/admin/base/user/role/queryPermissionsByRoleId', params)
  },
  // 更新角色权限
  updateRolePermission (params) {
    return axios.post('/api/rendering/admin/base/user/role/updateRolePermissions', params)
  },
  // 验证部门是否存在
  validateOrganizationName (params) {
    return axios.post('/api/rendering/admin/base/user/organization/validateOrganizationName', params)
  },
  // 修改管理员基本信息
  updateAdminBase (params) {
    return axios.post('/api/rendering/admin/base/user/updateAdminBase', params)
  },
  // 根据id查询管理员基础信息
  queryAdminBase () {
    return axios.post('/api/rendering/admin/base/user/queryAdminBase')
  },
  // 列表处修改管理员、代理权限
  alterRolePermission (params) {
    return axios.post('/api/rendering/admin/base/user/role/updateAdminRole', params)
  },
  // 禅道工单集成
  getZentaoLoginUrl () {
    return axios.post('/api/rendering/admin/base/getZentaoLoginUrl')
  },
  // 导出excel
  exportRole() {
    return exportAxios('/api/rendering/admin/base/user/role/exportRole')
  },
  exportNoticeData(param) {
    return axios.post('/api/rendering/admin/front/promotion/exportNoticeData', param)
  },
  // 导出员工列表
  exportAdmin(param) {
    return exportAxios('/api/rendering/admin/base/user/exportAdmin', param)
  },
  // 批量修改权限
  batchUpdateAdminRole(params) {
    return axios.post('/api/rendering/admin/base/user/role/batchUpdateAdminRole', params)
  },
  // 批量修改属性
  batchUpdateOrganization(params) {
    return axios.post('/api/rendering/admin/base/user/updateOrganization', params)
  },
  // 获取国家下拉列表
  getProvinceOrCounty() {
    return axios.post('/api/rendering/admin/front/getProvinceOrCounty', {})
  },
}
